<template>
  <div
      :ref="`table-${indiceQuadro}-${indiceElemento}`"
      :key="`table-${indiceQuadro}-${indiceElemento}`"
      :class="`table-${indiceQuadro}-${indiceElemento}`"
      class="tabela-container"
      :style="{height: height}"
      style="overflow-y: hidden !important;"
  >
    <table
        fixed-header
        :style="elemento.tabelaPrecoOptions.tabelaStyle"
        style="width: 100%;"
    >
      <!--    <template v-slot:default></template>-->

      <thead v-if="elemento.tabelaPrecoOptions.tHeadExibir">
      <tr v-if="elemento.tabelaPrecoOptions.cabecalhoExibir && elemento.tabelaPrecoDataAux.nome">
        <!--<editor-fold desc="cabecalho">-->
        <th colspan="3"
            :class="cpCabecalhoTextoClass"
            :style="{
            ...elemento.tabelaPrecoOptions.cabecalhoStyle,
            ...{
              fontSize: `${$store.state.timelineMainContainerSize.h * (elemento.tabelaPrecoOptions.cabecalhoStyle.fontSize / 100)}px`,
              lineHeight: 1
            }
          }"
        >
          {{ elemento.tabelaPrecoDataAux.nome }}
        </th>
        <!--</editor-fold> cabecalho-->
      </tr>
      <tr>
        <!--        <th-->
        <!--            class="text-left"-->
        <!--            :class="cpTHeadTextoClass"-->
        <!--            :style="{-->
        <!--                ...elemento.tabelaPrecoOptions.tHeadStyle,-->
        <!--                fontSize:-->
        <!--                  `${$store.state.timelineMainContainerSize.h * (-->
        <!--                    elemento.tabelaPrecoOptions.tHeadStyle.fontSize / 100-->
        <!--                  )}px`-->
        <!--              }"-->
        <!--        >-->
        <!--          Código-->
        <!--        </th>-->
        <th
            class="text-left"
            :class="cpTHeadTextoClass"
            :style="{
                ...elemento.tabelaPrecoOptions.tHeadStyle,
                fontSize:
                  `${$store.state.timelineMainContainerSize.h * (
                    elemento.tabelaPrecoOptions.tHeadStyle.fontSize / 100
                  )}px`
              }"
        >
          Produto
        </th>
        <th
            class="text-left"
            :class="cpTHeadTextoClass"
            :style="{
                ...elemento.tabelaPrecoOptions.tHeadStyle,
                fontSize:
                  `${$store.state.timelineMainContainerSize.h * (
                    elemento.tabelaPrecoOptions.tHeadStyle.fontSize / 100
                  )}px`
              }"
        >
          Preço
        </th>
        <th
            class="text-left"
            :class="cpTHeadTextoClass"
            :style="{...elemento.tabelaPrecoOptions.tHeadStyle, color: 'rgba(0, 0, 0, 0)'}"
        >
          .
        </th>
      </tr>
      </thead>

      <tbody>
      <!--        :id="`scrollContainer_${divisaoQuadroAtualLoop.quadroIndex}_${divisaoQuadroAtualLoop.divisaoNumero}_scrollPoint_${k}`"-->
      <tr
          class="testeBla"
          v-for="(item, k) in items"
          :key="item.id"
      >
        <!--        <td-->
        <!--            :class="cpTBodyTextoClass"-->
        <!--            :style="{-->
        <!--                ...elemento.tabelaPrecoOptions.tBodyStyle,-->
        <!--                fontSize:-->
        <!--                  `${$store.state.timelineMainContainerSize.h * (-->
        <!--                    elemento.tabelaPrecoOptions.tBodyStyle.fontSize / 100-->
        <!--                  )}px`-->
        <!--              }"-->
        <!--        >-->
        <!--          {{ ('00000000' + item.codigo).slice(-8) }}-->
        <!--        </td>-->
        <td
            :class="cpTBodyTextoClass"
            :style="{
                ...elemento.tabelaPrecoOptions.tBodyStyle,
                fontSize:
                  `${$store.state.timelineMainContainerSize.h * (
                    elemento.tabelaPrecoOptions.tBodyStyle.fontSize / 100
                  )}px`
              }"
        >
          {{ item.mercadoria_descricao }}
        </td>
        <td
            :class="cpTBodyTextoClass"
            :style="{
                ...elemento.tabelaPrecoOptions.tBodyStyle,
                fontSize:
                  `${$store.state.timelineMainContainerSize.h * (
                    elemento.tabelaPrecoOptions.tBodyStyle.fontSize / 100
                  )}px`
              }"
        >
          R${{ formataPrecoPlayer(item.preco) }}
        </td>
        <td
            :class="cpTBodyTextoClass"
            :style="elemento.tabelaPrecoOptions.tBodyStyle"
        >
          <v-row no-gutters>
            <v-col>
              <v-chip
                  v-if="item.destaque && elemento.tabelaPrecoOptions.destaqueExibir"
                  class="ma-2"
                  :color="elemento.tabelaPrecoOptions.destaqueStyle.backgroundColor"
                  :text-color="elemento.tabelaPrecoOptions.destaqueStyle.color"
                  :outlined="elemento.tabelaPrecoOptions.destaqueOutlined"
                  :label="!elemento.tabelaPrecoOptions.destaqueRounded"
                  :style="{
                    fontSize:
                      `${$store.state.timelineMainContainerSize.h * (
                        elemento.tabelaPrecoOptions.tBodyStyle.fontSize / 100
                      )}px`,
                      height: `${$store.state.timelineMainContainerSize.h * (
                        elemento.tabelaPrecoOptions.tBodyStyle.fontSize / 100
                      ) + 6}px`,
                  }"
              >
                <v-icon
                    left
                    v-if="elemento.tabelaPrecoOptions.destaqueIcone
                                                 && elemento.tabelaPrecoOptions.destaqueTexto.length > 0
                                                 && elemento.tabelaPrecoOptions.destaqueIconePosition=='left'"
                    :style="{
                    fontSize:
                      `${$store.state.timelineMainContainerSize.h * (
                        elemento.tabelaPrecoOptions.tBodyStyle.fontSize / 100
                      )}px`
                  }"
                >
                  {{ elemento.tabelaPrecoOptions.destaqueIcone }}
                </v-icon>

                {{ elemento.tabelaPrecoOptions.destaqueTexto }}

                <v-icon
                    v-if="elemento.tabelaPrecoOptions.destaqueIcone
                                                 && elemento.tabelaPrecoOptions.destaqueTexto.length == 0"
                >
                  {{ elemento.tabelaPrecoOptions.destaqueIcone }}
                </v-icon>

                <v-icon
                    right
                    v-if="elemento.tabelaPrecoOptions.destaqueIcone
                                                 && elemento.tabelaPrecoOptions.destaqueTexto.length > 0
                                                 && elemento.tabelaPrecoOptions.destaqueIconePosition=='right'"
                >
                  {{ elemento.tabelaPrecoOptions.destaqueIcone }}
                </v-icon>

              </v-chip>
            </v-col>
          </v-row>
          &nbsp;
        </td>
      </tr>

      </tbody>

    </table>
  </div>
</template>

<script>
import {timelineMixin} from "../timelineMixin";
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

export default {
  name: "TabelaPreco",
  props: {
    divisaoQuadroAtualLoop: {
      type: [Object, Boolean],
      required: false
    },
    elemento: {
      type: [Object, Boolean],
      required: false
    },
    height: {
      type: [Number, Boolean],
      required: false
    },
    indiceQuadro: {
      type: [Number, String, Boolean],
      required: false
    },
    numeroDivisao: {
      type: [Number, Boolean],
      required: false
    },
    indiceElemento: {
      type: [Number, Boolean],
      required: false
    },
  },
  mixins: [timelineMixin],
  data() {
    return {
      nome: "",
      loading: false,
      items: [],
      cor: "red",

      scrollOffsetTop: 0,
      scrollIntervalId: 0
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.wrapperScrollStart();
    });
  },

  created() {
    this.getFromApi();
  },

  watch: {
    currentSlideIndex: {
      handler() {
        this.wrapperScrollStart();
      },
      // deep: true,
    },

    //pega do store(q recebeu do ajax do showMysSlide) e passa para as vars locais
    elemento: {
      handler() {
        if (this.$store.state.modoExibicaoSlides == 'player') {
          this.nome = this.elemento.tabelaPrecoDataAux.nome;
          this.items = this.elemento.tabelaPrecoDataAux.items;
        }
      },
//      deep: true,
    }
  },

  methods: {
    wrapperScrollStart() {
      clearInterval(this.scrollIntervalId);
      const wrapper = this.$refs[`table-${this.indiceQuadro}-${this.indiceElemento}`];

      if (wrapper && this.currentSlideIndex == this.indiceQuadro ) {
        setTimeout(() => {
          this.scrollIntervalId = setInterval(() => {
            this.wrapperScroll();
          }, 5000);

          console.log('start scroll int id: ' + this.scrollIntervalId);
        }, 50);
      }else{
        clearInterval(this.scrollIntervalId);
      }
    },

    wrapperScroll() {
      const wrapper = this.$refs[`table-${this.indiceQuadro}-${this.indiceElemento}`];

      if (wrapper && this.currentSlideIndex == this.indiceQuadro ) {
        const tr = wrapper.querySelector("table > tbody > tr");

        if (tr) {
          const amount = tr.offsetHeight / 2; //faz o scroll 1/2 da altura da linha

          wrapper.scrollBy(0, amount); // horizontal and vertical scroll increments

          console.log('next scroll int id: ' + this.scrollIntervalId);
          // console.log(wrapper.offsetHeight, wrapper.scrollTop, wrapper.scrollHeight);

          if (wrapper.offsetHeight + wrapper.scrollTop >= wrapper.scrollHeight) {
            clearInterval(this.scrollIntervalId);
            setTimeout(() => {
              // volta ao topo
              wrapper.scrollTo(0, 0);

              // e inicia o scroll de novo
              this.wrapperScrollStart()
            }, 5000);
          }
        }
      }else{
        clearInterval(this.scrollIntervalId);
      }
    },

    getFromApi() {
      if (!this.elemento || this.elemento.tipo != 'tabela-preco') {
        return false;
      }

      this.loading = true;

      // let params = {
      //   filters: this.filters,
      //   sortBy: sortBy,
      //   sortDesc: sortDesc,
      //   page: page,
      //   itemsPerPage: itemsPerPage,
      // };
      if (this.$store.state.modoExibicaoSlides == 'edicao') {
        let params = {
          // filters: this.filters,
          // sortBy: sortBy,
          // sortDesc: sortDesc,
          // page: page,
          // itemsPerPage: itemsPerPage,
          filialId: this.$store.state.showMySlide.myFilialId
        };

        axios.get(
            '/tabelas-precos/' + this.elemento.tabelaPrecoDataAux.id + '/itens',
            {params: params}).then((response) => {
          this.nome = response.data.header.nome;
          this.items = response.data.items;
          this.loading = false;

          // this.goTo();
        }, (error) => {
          console.log(error);
        }).catch(error => {
          console.log(error)
          // this.errored = true
        }).finally(() => this.loading = false);
      } else if (this.$store.state.modoExibicaoSlides == 'player') {
        this.nome = this.elemento.tabelaPrecoDataAux.nome;
        this.items = this.elemento.tabelaPrecoDataAux.items;
      }
    },
  },

  computed: {
    cpCabecalhoTextoClass() {
      let aClass = [];
      for (const k in this.elemento.tabelaPrecoOptions.cabecalhoTextoClass) {
        if (k != 'estilo') {
          aClass.push(this.elemento.tabelaPrecoOptions.cabecalhoTextoClass[k]);
        }
      }

      aClass = aClass.concat(this.elemento.tabelaPrecoOptions.cabecalhoTextoClass.estilo);

      return aClass;
    },

    cpCabecalhoBackgroundImgHeight() {
      let height = "";

      switch (this.elemento.tabelaPrecoOptions.cabecalhoTextoClass.size) {
        case "text-h1":
          height = "8rem";
          break;
        case "text-h2":
          height = "6rem";
          break;
        case "text-h3":
          height = "5rem";
          break;
        case "text-h4":
        case "text-h5":
        case "text-h6":
          height = "4rem";
          break;
      }

      return height;
    },

    cpTHeadTextoClass() {
      let aClass = [];
      for (const k in this.elemento.tabelaPrecoOptions.tHeadTextoClass) {
        if (k != 'estilo') {
          aClass.push(this.elemento.tabelaPrecoOptions.tHeadTextoClass[k]);
        }
      }

      aClass = aClass.concat(this.elemento.tabelaPrecoOptions.tHeadTextoClass.estilo);

      return aClass;
    },

    cpTBodyTextoClass() {
      let aClass = [];

      for (const k in this.elemento.tabelaPrecoOptions.tBodyTextoClass) {
        if (k != 'estilo') {
          aClass.push(this.elemento.tabelaPrecoOptions.tBodyTextoClass[k]);
        }
      }

      aClass = aClass.concat(this.elemento.tabelaPrecoOptions.tBodyTextoClass.estilo);

      return aClass;
    },
  }
}
</script>

<style scoped>

table thead th {
  position: sticky;
  top: 0;
}

table {
  border-collapse: collapse;
}

table tbody td {
  border-bottom: 1px solid #ddd;
}

th, td {
  padding: 4px;
  text-align: left;
}

.tabela-container {
  scrollbar-width: none;
  scroll-behavior: smooth;
}

.tabela-container::-webkit-scrollbar {
  height: 0px;
  width: 0px;
}

</style>
